module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAYAAAAGCAYAAADgzO9IAAAACXBIWXMAAAsTAAALEwEAmpwYAAAAGXRFWHRTb2Z0d2FyZQBBZG9iZSBJbWFnZVJlYWR5ccllPAAAADtJREFUeNpi/P//PwM2wATED4D4Pxp+wADUYQDEH/4jAIhtAJIA4QQkCRCbgRHJjglQugBEMOKyHCDAANhfOpHRtgiSAAAAAElFTkSuQmCC"


//////////////////
// WEBPACK FOOTER
// ./static/images/head/白色小三角.png
// module id = j1D0
// module chunks = 0